import { Collapse } from 'bootstrap/dist/js/bootstrap.esm.min'

Array.from( document.querySelectorAll( '.wp-toolkit .collapse' ) )
     .forEach( collapseNode => new Collapse( collapseNode, {
       toggle: false,
     } ) )
